<template>
  <div>
    <div class="bg-purple-light">
      <div class="content">
        <Navbar is-logged-in />

        <div
          v-if="assessmentResult !== null"
          class="d-flex justify-content-center"
        >
          <div class="white-box my-5 mx-3 pt-5 pb-2 text-center">
            <img
              class="image"
              src="@/assets/image/success-dhm.png"
              alt="success-dhm"
            >
            <h4 class="mt-3 font-weight-bold">
              {{ $t("success-assessment.text-one") }}
            </h4>
            <h5 class="mt-3 text-black-50 m-0 text-css">
              {{ $t("success-assessment.text-two") }}
            </h5>
            <h5 class="text-black-50 m-0 text-css">
              {{ $t("success-assessment.text-three") }}
            </h5>
            <div class="row">
              <div class="col-3" />
              <div class="col-6">
                <div class="mt-4 text-four text-left text-css">
                  <div class="row">
                    <strong
                      class="col-6"
                    >{{ $t("success-assessment.text-four.name") }}
                    </strong>
                    <span class="col-6 text-secondary">{{ (assessmentResult.user && assessmentResult.user.fullname) || '' }}</span>
                  </div>
                  <div class="row">
                    <strong
                      class="col-6"
                    >{{ $t("success-assessment.text-four.number") }}
                    </strong>
                    <span class="col-6 text-secondary">{{ (assessmentResult.user && assessmentResult.user.phoneNumber) || 'N/A' }}</span>
                  </div>
                  <div class="row">
                    <strong
                      class="col-6"
                    >{{ $t("success-assessment.text-four.company") }}
                    </strong>
                    <span class="col-6 text-secondary">{{
                      (assessmentResult.user && assessmentResult.user.company) ? assessmentResult.user.company.name : ''
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="col-3" />
            </div>
            <div class="d-flex justify-content-center mt-5 px-5">
              <div :class="`w-100 px-5 py-3 ${assessmentResult.riskEng === 'high' ? 'danger-box' : (assessmentResult.riskEng === 'medium' ? 'medium-box' : 'success-box') }`">
                <div class="mb-4">
                  <strong>
                    {{ $t("success-assessment.risk-one") }}
                    <template v-if="$i18n.locale === 'en'">
                      {{ riskStatusTextEn }}
                    </template>
                    <template v-if="$i18n.locale === 'id'">
                      {{ riskStatusTextId }}
                    </template>
                    {{ $t("success-assessment.risk-two") }}
                  </strong>
                </div>
                <div v-if="$i18n.locale === 'en'">
                  <div
                    v-for="(recommendation, r) of assessmentResult.recommendationEng"
                    :key="r"
                  >
                    {{ recommendation }}
                  </div>
                </div>
                <div v-if="$i18n.locale === 'id'">
                  <div
                    v-for="(recommendation, r) of assessmentResult.recommendationIdn"
                    :key="r"
                  >
                    {{ recommendation }}
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <strong
                class="text-primary cursor-pointer"
                @click="openModal('successAssessment', true)"
              >
                {{ $t("success-assessment.click-here") }}
              </strong>
              {{ $t("success-assessment.detail") }}
            </div>
            <h4 class="mt-4">
              <small>
                <strong>
                  {{ $t("success-assessment.contact-person") }}
                </strong>
              </small>
            </h4>
            <div class="row px-4 m-0 mt-4 text-left">
              <div class="col-4">
                <h6>
                  <small>
                    <strong>
                      {{ $t("success-assessment.medic") }}
                    </strong>
                  </small>
                </h6>
                <span
                  v-for="(list, index) in assessmentResult.doctors"
                  :key="index"
                >
                  <h6 class="text-black-50">
                    <small>
                      <strong>
                        {{ list.name }}
                      </strong>
                    </small>
                  </h6>
                  <h6 class="text-black-50 pb-2">
                    <small>
                      <strong> ({{ list.phoneNumber }}) </strong>
                    </small>
                  </h6>
                </span>
              </div>
              <div class="col-4">
                <h6>
                  <small>
                    <strong>
                      {{ $t("success-assessment.hr") }}
                    </strong>
                  </small>
                </h6>
                <span
                  v-for="(list, index) in assessmentResult.hrs"
                  :key="index"
                >
                  <h6 class="text-black-50">
                    <small>
                      <strong>
                        {{ list.name }}
                      </strong>
                    </small>
                  </h6>
                  <h6 class="text-black-50 pb-2">
                    <small>
                      <strong> ({{ list.phoneNumber }}) </strong>
                    </small>
                  </h6>
                </span>
              </div>
              <div class="col-4">
                <h6>
                  <small>
                    <strong>
                      {{ $t("success-assessment.hsec") }}
                    </strong>
                  </small>
                </h6>
                <span
                  v-for="(list, index) in assessmentResult.hsecs"
                  :key="index"
                >
                  <h6 class="text-black-50">
                    <small>
                      <strong>
                        {{ list.name }}
                      </strong>
                    </small>
                  </h6>
                  <h6 class="text-black-50 pb-2">
                    <small>
                      <strong> ({{ list.phoneNumber }}) </strong>
                    </small>
                  </h6>
                </span>
              </div>
            </div>
            <div class="row m-0 mt-5">
              <div class="col-4" />
              <router-link
                class="btn btn-info btn-block mt-3 mb-5 py-2 col-4"
                tag="div"
                to="my-assessment"
              >
                <small class="font-weight-bold">
                  {{ $t("success-assessment.button-back") }}
                </small>
              </router-link>
              <div class="col-4" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ViewAssessment
      v-if="modal.successAssessment"
      :id-assessment="idAssessment"
      @openModal="openModal"
    />
  </div>
</template>

<script>
import { format } from 'date-fns'
import Navbar from '@/components/Navbar'
import ViewAssessment from '@/components/modal/ModalViewAssessment'
import Api from '@/utils/Api'

export default {
  name: 'SuccessAssessment',

  components: {
    Navbar,
    ViewAssessment
  },

  props: {
    assessmentResult: {
      type: Object,
      default: () => ({
        risk: '',
        recommendationEng: [],
        recommendationIdn: [],
        doctor: {
          name: '',
          phoneNumber: '',
          company: {
            name: '',
            code: ''
          }
        },
        hr: {
          type: '',
          name: '',
          phoneNumber: '',
          company: {
            name: '',
            code: ''
          }
        },
        hsec: {
          type: '',
          name: '',
          phoneNumber: '',
          company: {
            name: '',
            code: ''
          }
        },
        user: {
          fullname: '',
          phoneNumber: '',
          company: {
            name: ''
          }
        }
      })
    }
  },

  data () {
    return {
      modal: {
        successAssessment: false
      },
      idAssessment: ''
    }
  },

  computed: {
    riskStatusTextEn () {
      switch (this.assessmentResult.riskEng) {
        case 'low':
          return 'Fit to Work'
        case 'medium':
          return 'Fit with Note'
        case 'high':
          return 'Temporary unfit'
        default:
          return ''
      }
    },
    riskStatusTextId () {
      switch (this.assessmentResult.riskIdn) {
        case 'rendah':
          return 'Fit untuk bekerja'
        case 'sedang':
          return 'Layak Kerja Dengan Catatan'
        case 'tinggi':
          return 'Tidak Layak Kerja Untuk Sementara Waktu'
        default:
          return ''
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    if (!to.params.assessmentResult) {
      next({
        name: 'my_dhm',
        params: {
          lang: to.params.lang
        }
      })
    } else {
      next()
    }
  },

  mounted () {
    this.changeSubmissionStatus()
    this.idAssessment = this.assessmentResult.id
    this.updateProfile()
  },

  methods: {
    openModal (modalName, isOpen) {
      this.modal[modalName] = isOpen
    },
    changeSubmissionStatus () {
      const dataLoc = JSON.parse(localStorage.getItem('profile'))
      dataLoc.lastSubmissionDate = format(new Date(), 'yyyy-MM-dd')
      localStorage.data = JSON.stringify(dataLoc)
    },
    async updateProfile () {
      const { data: profile } = await Api.users.me()
      localStorage.profile = JSON.stringify(profile)
    }
  }
}
</script>

<style scoped>
.content {
  background-image: url("../assets/image/bg-2.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 100vh;
}
.white-box {
  background: white;
  width: 1000px;
  border-radius: 18px;
}
.image {
  width: 250px;
}
.text-css {
  font-size: 15px;
}
.success-box {
  background-color: #d4ecdc;
  color: #35603e;
  border: 2px solid #34663e;
  border-radius: 8px;
}
.danger-box {
  background-color: #ecd4d4;
  color: #603535;
  border: 2px solid #663434;
  border-radius: 8px;
}
.medium-box {
  background-color: #edf50a;
  color: #603535;
  border: 2px solid #FA6400;
  border-radius: 8px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
